import styled from 'styled-components';
import {
  ContentContainer,
  FixedWidth,
  DataValue
} from "../../../CommonComponents/commonStyles";
import {
  NoChangeSpace
} from "../../NPA/Pages/Step1Setup/styles";
import { Table } from "antd";
import { ContainerCard } from "../../../CommonComponents/FlowCard/styles";

export const LinkStyle = styled(NoChangeSpace)`
  width: 336px;
  font-size: ${props => props.theme.fontSize.secondary};
  margin-bottom: ${props => props.marginBottom};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 40px;
    font-size: ${props => props.theme.fontSize.tertiary};
    line-height: 1.75;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    width: 300px; 
  }
`

export const AccountWrap = styled.div`
@media only screen and (min-width: 320px) and (max-width: 767px) {
  /* display: flex;
  align-items: center;
  justify-content: space-between; */
  margin-bottom: 42px;
}
`
export const LoaderContainer = styled.div`
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const MainDisplayFlex = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${props => props.marginBottom};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: unset;
  }
`

export const DisplayFlex = styled(MainDisplayFlex)`
  display: flex;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: flex;
  }
`

export const MainHead = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h1}
  font-weight: ${props => props.theme.fontWeight.normal};
  line-height: 1.14;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor}
  margin-bottom: ${props => props.marginBottom};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h2}
    line-height: 1.17;
    margin-bottom: ${props => props.MmarginBottom}
  }
`

export const Content = styled.h1`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.5;
  color: ${props => props.theme.fontColors.textColor};
  margin-bottom: ${props => props.marginBottom};
  word-break: break-word;
  margin-right: 10px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: 1.43;
    margin-bottom: 0;
    margin-right: 0;
  }
`

export const FundId = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.h4};
  color: ${props => props.theme.fontColors.textColor};
  max-width: 167px;
  overflow: hidden;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h5}
    letter-spacing: ${props => props.theme.letterSpacing.zero};
    max-width: 139px;
  }
`

export const SubHead = styled.h1`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  line-height: 1.25;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor}
  padding-bottom: ${props => props.paddingBottom};
  border-bottom: ${props => props.borderBottom};
  margin-bottom: ${props => props.marginBottom};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h5}
    font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
    line-height: 1.3;
    padding-bottom: ${props => props.MpaddingBottom};
    margin-bottom: ${props => props.MmarginBottom};
  }
`

export const Border = styled.div`
  border-bottom: 1px solid  ${props => props.theme.colors.border};
  margin-bottom: 8px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 8px;
  }
`;

export const BalanceSummaryWrap = styled.div`
  width: 320px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100%;
    margin-bottom: 15px;
  }
`

export const BalanceValue = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.5;
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`
export const ImageWrap = styled.img``

export const SelecttFilter = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
 `
export const FilterLabel = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: normal;
  line-height: 1.13;
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.textColor};
  margin-right:10px;
 `

export const FlexCenter = styled(DisplayFlex)`
  align-items: center;
  margin-left:  ${props => (props.marginLeft === undefined) ? "0px" : props.marginLeft};
  margin-bottom: ${props => (props.marginBottom === undefined) ? "0px" : props.marginBottom};
  margin-top: ${props => (props.marginTop === undefined) ? "0px" : props.marginTop};
  justify-content: ${props => (props.spaceBetween === undefined) ? "space-between" : props.spaceBetween};
  position: absolute;
  bottom: 0;
  .ant-select ul, .ant-select ol{
    display:block !important;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    justify-content:space-between;
    position: relative;
  }
`
export const DocCentreContentWrapper = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
 font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.5;
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.thead};
  margin-left: ${props => (props.marginLeft === undefined) ? "0px" : props.marginLeft};
  margin-right: ${props => (props.marginRight === undefined) ? "0px" : props.marginRight};
  flex-shrink: 0;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: 1.57;
    margin-left: 0;
    width:80px;
  }
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
  margin-bottom: 30px;
  margin-left: 0px;
  }
  @media only screen and (min-width: 1024px) and (max-width: 1439px) {
    margin-left: ${props => (props.ml === undefined) ? "0px" : props.ml};
  }
`;

export const ContentContainerSpace = styled(ContentContainer)`
  padding: 0 9% 0 9%;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 0 6.4% 0 6.1%;
  } 
  @media only screen and (max-width: 991.91px) and (min-width: 768px) {
    padding: 0px 20px;
  }
`;
export const FixedWidthSpace = styled(FixedWidth)`
  @media (max-width: 1440px) {
    padding: 0;
  }
  @media (max-width: 576px) {
    padding: 0;
  }
`;

export const OtherTransactionHeading = styled.div`
font-family: ${props => props.theme.fontFamily.berkeleyStd};
font-size: ${props => props.theme.fontSize.h1};
color: ${props => props.theme.fontColors.headingColor};
letter-spacing: ${props => props.theme.letterSpacing.normal};  
line-height: 1.14;
margin-bottom: 30px;
@media only screen and (min-width: 320px) and (max-width: 767px) {    
  font-size: 36px;
  margin-bottom: 20px;
  line-height: 1.17;    
}
`;

export const SectionHeading = styled.h4`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  margin: 0 30px 0 0;
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h5};
  }
`;

export const Heading = styled(DataValue)`
  line-height: 1.6rem;
`;

export const CustomizedFlowCard = styled.div`
  .ant-card{
    .ant-card-body{
      &:after{
        display: block;
        position: relative;
        z-index: 2;
        content: '';
        height: 3px;
        width: 100%;
        background: #fff;
        margin-top: -2px;        
      }
      .ant-card-grid{
        box-shadow: none;
        @media only screen and (max-width: 768px) {
          padding-bottom: 10px;
            min-height:71px;
        }    
        @media only screen and (max-width: 991px) {
            padding-bottom: 10px;
            min-height:83px;
          };           
       
      }
    } 
  } 
`;

export const CustomSectionSpacing = styled.div`
margin: 50px 0;
@media only screen and (max-width: 767px) {
  margin: 40px 0px 0px 0;
}
`;

export const FlexContainer = styled.div`
display: flex;
align-items: center;
margin-bottom: 20px;
@media only screen and (max-width: 767px) {
  justify-content: space-between;
}
`;


export const PoolTable = styled(Table)`
  .ant-table {
    border-top: solid 1px #d4d4d4;
    font-size: ${props => props.theme.fontSize.primary};
    @media only screen and (max-width: 991px) {
      font-size: ${props => props.theme.fontSize.secondary};
      table{
        display: flex;            
        flex-direction: column;
        width: 100%;
      }      
    }    
    .ant-table-thead {
      font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
      & > tr {
        background-color: #ffffff;
        border-top: solid 1px #d4d4d4;
        border-bottom: solid 1px #d4d4d4;
      }
      & > tr > th {
        padding: 16px 10px;
        color: ${props => props.theme.fontColors.headingColor};        
        background: ${props => props.theme.backgroundColor.layoutLight};
        font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
        line-height: ${props => props.theme.lineHeight.tableFont};
        letter-spacing: ${props => props.theme.letterSpacing.normal};
        @media only screen and (max-width: 991px) {          
          &.hide-col-title-in-mobile{
            display: none;
          }
        }
      }
    }
    .ant-table-tbody {
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
      & > tr > td {
        padding: 10px;
        font-family: ${props => props.theme.fontFamily.helveticaNeue};
        color: ${props => props.theme.fontColors.textColor};
        letter-spacing: ${props => props.theme.letterSpacing.point6};
        border-bottom: none;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
      }
    }
    .ant-table-column-title {
      transform: none;
    }
    .ant-table-content{           
      @media only screen and (max-width: 991px) {
        width: 100%;
        .ant-table-thead > tr{
          border: none;
          padding: 0;
        }
        tr{
          display: flex;
          padding: 0 15px;          
          flex-wrap: wrap;
          outline: 1px solid ${props => props.theme.colors.white};
          border-bottom: 1px solid ${props => props.theme.backgroundColor.layoutDark};
          &:hover{
            td{
              background: transparent !important;
            }
          }
          td{
            border-bottom: 1px solid ${props => props.theme.border.pill};
            &:nth-last-child(-n+2){
              border-bottom: none;
            }
            &:nth-last-child(2):nth-child(odd){
              border-bottom: 1px solid ${props => props.theme.border.pill};
            }
          }
          th,td{         
            width: 50%; 
            padding:10px 10px 10px 0px;                        
            &.cell-w100{
              width: 100%; 
            }
            &.cell-w33{
              width: 33.33%; 
            }         
          }
          th.radio-input-col{
            width: auto;
            background-color: transparent;
            padding: 10px 15px 20px 0;
            border: none;
            font-family: ${props => props.theme.fontFamily.helveticaNeue}; 
            &:last-child{
              padding-right: 0;
            }
            .ant-table-column-title{
              display: flex;
            }
          }
        }
        .investment-pool-title{
          width: 100%;
          font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
          color: ${props => props.theme.fontColors.headingColor};
          letter-spacing: ${props => props.theme.letterSpacing.zero} ;
          padding-bottom: 5px;
          border: none !important;
        }         
      }
    }
  }  
`;

export const PrintBtn = styled.div`
  float: right;
  margin-top: 10px;
`
export const ContentMaker = styled.div`
white-space: pre-line;
`;

export const ReversedSection = styled.div`
  display: flex;
  margin-bottom: 50px;
  max-width: 500px;
  div{
    display: flex;
  }
`
export const Pipe = styled.span`
  margin: 3px 14px;
  border-left: 1px solid #ccc;
  height: 16px;
`

export const ItlicText = styled.span`
  display: inline-block;
  width: 100%;
  font-size: ${props => props.theme.fontSize.secondary};
  font-style: italic;
`;